import React from 'react'
import { Icon } from '@LTIDashboard/modules/common'

export function Header({ title, status, hideIcon = false }) {
  console.log(title)
  console.log(hideIcon)
  return (
    <div className="d-flex align-items-center my-3">
      <Icon status={status} hidden={hideIcon} />
      <h1 className="d-inline my-1 ml-3">{title}</h1>
    </div>
  )
}
